// return a fallback state depending on how data is filtered in searchDiscounts

export function getFallbackStateDiscounts({ isLoading, allData, filteredData }) {
  if (isLoading) {
    return { state: "loading" };
  }

  if (!allData || allData.length === 0) {
    return { state: "noData" };
  }

  if (filteredData.length === 0) {
    return { state: "noMatch" };
  }

  return { state: "ok" };
}
